module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-3-2.48925357.png";